/* eslint-disable */
export default {
  logging: 'ログ記録中...',
  logCall: '通話のログ記録',
  editLog: 'ログの編集',
  select: '一致するレコードの選択',
  OnHold: '保留中',
  Ringing: '呼び出し中',
  CallConnected: '通話を接続済み',
  unknownUser: '不明なユーザー',
  unknownNumber: '匿名',
  unavailable: '連絡不可',
  viewDetails: '詳細を表示',
  addEntity: '新規作成',
  addLog: 'ログ',
  text: 'テキスト',
  call: '通話',
  addContact: '連絡先を追加',
  missedCall: '不在',
  inboundCall: '着信',
  outboundCall: '発信',
  from: '発信元',
  to: '発信先',
  hangup: '通話を終了',
  accept: '応答',
  toVoicemail: 'ボイスメールへ',
  anonymous: '匿名',
  mergeToConference: 'アクティブな通話とマージ',
  hold: '保留',
  unhold: '保留を解除',
  transfer: '転送',
  reject: '拒否',
  switchCall: 'このアプリに通話を切り替え',
  callSwitch: '通話の切り替え',
  comfirmContext:
    '現在、{displayName}とのアクティブな通話中です。このデバイスで通話を続行しますか？',
  comfirmCancelButton: 'キャンセル',
  comfirmOKButton: '切り替え',
  ignore: '無視',
  holdAndAnswer: '保留して応答',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
